import dayjs from "dayjs";
const isSameOrAfter = require("dayjs/plugin/isSameOrAfter");
dayjs.extend(isSameOrAfter);

const isLessThanDay = (dayA, dayB) => {
  return dayjs(dayA).isBefore(dayjs(dayB));
};

const isLessThanToday = (day) => {
  return dayjs(day).isBefore(dayjs());
};

const isMoreThanDay = (dayA, dayB) => {
  return dayjs(dayA).isAfter(dayjs(dayB));
};

const isMoreThanToday = (day) => {
  return dayjs(day).isAfter(dayjs());
};

const isMoreThanOrSameDay = (dayA, dayB) => {
  return dayjs(dayA).isSameOrAfter(dayjs(dayB));
};

export {
  isLessThanDay,
  isLessThanToday,
  isMoreThanDay,
  isMoreThanToday,
  isMoreThanOrSameDay,
};
